import moment from 'moment';
import { CellProps } from './types';


const DateSubmittedCell = ({ cell, className }: CellProps) => {
  const date = cell.getValue();

  return (
    <div className={`color-gray-2 ${className}`}>
      {moment(date).format('MMMM D, YYYY')}
    </div>
  );
};

export default DateSubmittedCell;
